import React, { useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink } from "react-router-dom";

const MobileNavLinks = ({ navRoutesArray }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: { xs: "block", md: "none" },
      }}
    >
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={handleClick}
      >
        <MenuIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {navRoutesArray.map(({ route, title }) => (
          <MenuItem
            key={route}
            component={RouterLink}
            to={route}
            onClick={handleClose}
          >
            {title}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default MobileNavLinks;
